export default function ResurseUmanePage() {
  const conducere = [
    ["Director", "Rus Anca Crina"],
    ["Director adjunct", "China Maria"],
    ["Consilier educativ", "Botiș Sorina Mihaela"],
  ];

  const ca = [
    ["Președinte", "prof. Rus Anca Crina"],
    ["Secretar", "Chiș Garofița"],
    ["Membrii", "prof. Prună Ștefan, prof. Lupșa Simona, prof. Pop Daniel Vasile, Mitrea Marcel reprezentant al primarului, Oros Marin Ioan reprezentant al consiliului local, Conea Alexandru reprezentant al consiliului local, Gyorgy Mădălina reprezentant al părinților membru suplean, Piron Ioana reprezentant al părinților membru suplean, Takacs Tamara Andreea reprezentant al elevilor membru suplean, Covaciu Gheorghe reprezentant agent economic, Szigeti Zoltan reprezentant agent economic, prof. Botiș Sorina lider sindicat SLIMM observator, prof. înv. prim. Sas Dacian lider sindicat FSHMM observator"]
  ]

  const ceac = [
    ["Coordonator", "prof. Covaci Georgiana"],
    ["Membrii", "prof. Beci Cristina Veturia, prof. Moș Amalia Oana Alina, prof. Miklos Eniko Beata, prof. înv. primar Tamas Erzsebet"],
    ["Reprezentantul elevilor", "Popa Lorena Vanesa Valeria"],
    ["Reprezentantul părinților", "Takacs Florina Valeria"],
    ["Reprezentatul administrației locală", "Konya Lucian"],
  ];

  const catedre = [
    [
      "Catedra de limbă și comunicare",
      "prof. Tohătan Anica (Limba și Literatura Română), prof. China Maria (Limba și Literatura Română), prof. Covaci Georgiana (Limba și Literatura Română), prof. Moș Amalia Oana (Limba Engleză), prof. Pașca Mihaela Adriana (Limba Engleză), prof. Kis-Toth Zsofia (Limba Engleză), prof. Checean Mariana (Limba Franceză), prof. Rad Adreea Vasilica (Limba Franceză)",
    ],
    [
      "Catedra de matematică și științe",
      "prof. Beci Cristina-Veturia (Biologie), prof. Varga Andrea (Matematică), prof. Ionuți Bogdan-Doru (Matematică), prof. Ticle Andreea (Matematică), prof. Pinte Camelia-Gabriela (Fizică), prof. Lupșa Simona (Chimie)",
    ],
    [
      "Catedra de istorie-geografie",
      "prof. Prună Ștefan-Paul (Istorie), prof. Miklos Eniko-Beata (Geografie)",
    ],
    [
      "Psihologie - socio-umane",
      "prof. Sabou Alina-Crina (Educație Socială), prof. Oros Simona-Lucia (Economie/Ed. Antreprenorială/Ed. Tehnologică), prof. Pop Daniel Ioan",
    ],
    ["Consilier școlar", "Blasko Lavinia"],
    [
      "Catedra Tehnologii",
      "prof. Hiriș Marcel, prof. Profeanu Crina, prof. Ardelean Gheorghe Ovidiu, prof. Pop Delia Cornelia, prof. Gavriulas-Vijoli Florin, prof. Mărieș Andreea-Monica (Info&TIC), prof. Ticle Andreea (Info&TIC)",
    ],
    [
      "Catedra de religie-sport-arte",
      "prof. Botiș Sorina Mihaela (Religie ortodoxă), prof. Imre Monika (Religie reformată), prof. Brândușe Alexandra Lidia (Religie penticostală), prof. Pop Daniel-Vasile (Ed. fizică), prof. Pop Ion (Ed. fizică), prof. Topan Dorel-Georgel (Ed. plastică), prof. Gherman Sorina (Ed. muzicală)",
    ],
    [
      "Învățământ primar",
      "prof. înv. primar Pop Daniela-Grațiela, prof. înv. primar	Sas Dacian, prof. înv. primar	Băeș Monica-Maria, prof. înv. primar Mateașan Romana-Diana, prof. înv. primar Mateaș Lavinia-Mihaela, prof. înv. primar Molnar Anita-Monika, prof. înv. primar 	Kis-Toth Melinda",
    ],
    [
      "Învățământ preșcolar",
      "prof. înv. preșcolar Țicle Daniela, prof. înv. preșcolar Coroian Andreea-Amalia, ed. Sav Elvira Lucica, prof. înv. preșcolar Pop Andreea Liliana, prof. înv. preșcolar Tamas Erzsebet, prof. înv. preșcolar Cozma Ștefania-Florica",
    ],
  ];
  const auxiliar = [
    ["Contabil șef", "ec. Budai Kati"],
    ["Secretar șef", "Cristea Lucica"],
    ["Secretar", "Homorodan Maria"],
    ["Administrator patrimoniu", "Chiș Ioan"],
    ["Bibliotecar", "Chiș Garofița"],
    ["Laborant", "Moldovan Crina"],
    ["Administrator rețele calculatoare", "Koncz Maria Ilona"],
  ];
  const nedidactic = [
    ["Oros Marin", "Șofer"],
    ["Oros Florin", "Șofer"],
    ["Homorodan Marius", "Șofer"],
    ["Takacs Ervin", "Pază"],
    ["Covaciu Melin", "Muncitor"],
    ["Moldovan Liliana", "Îngrijitor de curățenie"],
    ["Imre Daniela", ""],
    ["Takacs Florina", ""],
    ["Augustin Victoria", ""],
    ["Vicsai Ioan Elemer", ""],
    ["Iliș Doinița", ""],
    ["Vicsai Andrea", ""],
    ["Homorodan Mirel", ""],
  ];

function renderTable(rows) {
  return (
    <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow mb-4">
      <tbody>
        {rows.map(([a, b], idx) => (
          <tr key={idx}>
            <td className="px-3 py-1 border-b align-top text-left w-1/2 text-sm leading-tight">
              {a}
            </td>
            <td className="px-3 py-1 border-b align-top text-left w-1/2 text-sm leading-tight">
              {Array.isArray(b)
                ? b.map((prof, i) => (
                    <span key={i} className="block mb-0.5">
                      {prof}
                    </span>
                  ))
                : typeof b === "string" && b.includes(",")
                ? b.split(/, ?/).map((prof, i) => (
                    <span key={i} className="block mb-0.5">
                      {prof}
                    </span>
                  ))
                : b}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}


  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="w-full bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-[rgb(0,51,51)] py-2 text-left">
              Conducere
            </h2>
          </div>
        </div>
        <section>
          <div className="flex flex-col gap-8">{renderTable(conducere)}</div>
        </section>
        <div className="w-full bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-[rgb(0,51,51)] py-2 text-left">
              Consiliul de administrație
            </h2>
          </div>
        </div>
        <section>
          <div className="flex flex-col gap-8">{renderTable(ca)}</div>
        </section>
         <div className="w-full bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-[rgb(0,51,51)] py-2 text-left">
              Comisia de evaluare și asigurare a calității
            </h2>
          </div>
        </div>
        <section>
          <div className="flex flex-col gap-8">{renderTable(ceac)}</div>
        </section>
        <div className="w-full bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-[rgb(0,51,51)] py-2 text-left">
              Catedre
            </h2>
          </div>
        </div>
        <section>
          <div className="flex flex-col gap-8">{renderTable(catedre)}</div>
        </section>
        <div className="w-full bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md mt-12">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-[rgb(0,51,51)] py-2 text-left">
              Personal Didactic Auxiliar
            </h2>
          </div>
        </div>
        <section>
          <div className="flex flex-col gap-8">{renderTable(auxiliar)}</div>
        </section>
        <div className="w-full bg-gradient-to-r from-[rgb(220,240,185)] to-[rgb(170,190,107)] shadow-md mt-12">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-[rgb(0,51,51)] py-2 text-left">
              Personal nedidactic
            </h2>
          </div>
        </div>
        <section>
          <div className="flex flex-col gap-8">{renderTable(nedidactic)}</div>
        </section>
      </main>
    </div>
  );
}
